import { render, staticRenderFns } from "./ShowCwInfo.vue?vue&type=template&id=1daecbe4&scoped=true&"
import script from "./ShowCwInfo.vue?vue&type=script&lang=js&"
export * from "./ShowCwInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daecbe4",
  null
  
)

export default component.exports